import * as types from './mutation_types'
import eventHub from '../lib/hub'
import * as api from '../api.js'
const utils = require('../utils')
const objectPath = require('object-path')
const querystring = require('querystring')
const WS = require('@subiz/wsclient').WS
const WS_URL = process.env.VUE_APP_WS_URL
const NUMBER_OF_SERVER_WS = process.env.VUE_APP_NUMBER_OF_SERVER_WS
let socket = null
let eventQueue = []

export const startConversation = async ({ commit, state }, { accountId, userId }) => {
	if (state.isOffline) return false
	const convo = await api.start(state.userMask, accountId, userId)
	commit(types.ADD_CONVO, { convo, position: 'begin' })
	return convo
}

export const createUser = async ({ commit, state }, accountId) => {
	if (state.isOffline) return false
	const user = await api.createUser(accountId)
	commit(types.SET_USER, user)
	return user
}

export const getUser = async ({ commit, state }, userId) => {
	if (state.isOffline) return
	const user = await api.getUser(userId)
	commit(types.SET_USER, user)
	return user
}

export const getSetting = async ({ commit, state }, { accountId, userId }) => {
	if (state.isOffline) return
	const userSetting = await api.getUserSetting(state.userMask, accountId, userId)
	commit(types.SET_SETTING, userSetting)
	commit(types.SET_SETTING_READY, true)
	commit(types.SET_BASE_SETTING_READY, true)
	return userSetting
}

export const getBaseSetting = async ({ commit, state }, accountId) => {
	if (state.isOffline) return
	const accountSetting = await api.getAccountSetting(accountId)
	commit(types.SET_BASE_SETTING, accountSetting)
	commit(types.SET_BASE_SETTING_READY, true)
	return accountSetting
}

export const getConversations = async ({ commit, state, dispatch }, { accountId, userId }) => {
	if (state.isOffline) return
	const ended = state.convoListEnd
	if (ended) return []

	var result = await api.listConversations(state.userMask, accountId, userId, {
		'x-user-mask': state.userMask,
	})

	let convoList = (result && result.conversations) || []
	convoList = utils.orderBy(convoList, 'last_actived', 'desc')
	commit(types.SET_CONVO_LIST, convoList)
	commit(types.SET_CONVO_LIST_END, true)

	// get events
	const convoIds = convoList.map(convo => convo.id)
	dispatch('getBatchEvents', { accountId, convoIds, limit: state.eventLimit })

	commit(types.SET_CONVO_LIST_READY, true)

	// process queued messages
	if (utils.size(eventQueue) > 0) {
		while (eventQueue.length > 0) {
			const event = eventQueue.shift()
			onEvent({ state }, event.message, event.offset)
		}
	}
	return convoList
}

export const sendMessage = async ({ commit, state }, { accountId, convoId, message }) => {
	if (state.isOffline) return
	const resp = await api.sendMessage(state.userMask, accountId, convoId, message)
	commit(types.ADD_EVENT, { convoId, event: resp })
	return resp
}

export const updateUser = async ({ commit, state }, { accountId, userId, data }) => {
	if (state.isOffline) return
	const resp = await api.updateUser(state.userMask, accountId, userId, data)
	commit(types.UPDATE_USER, data)
	return resp
}

export const updateWidgetSetting = async ({ commit, dispatch, state }, { accountId, userId, setting }) => {
	if (state.isOffline) return
	const resp = await api.updateUserSetting(state.userMask, accountId, userId, setting)
	await dispatch('getSetting', { accountId, userId })
	return resp
}

export const markAsSeenMessage = async ({ commit, state }, { accountId, convoId, messageId, userId }) => {
	if (state.isOffline) return
	commit(types.UPDATE_PONG_MESSAGE, {
		convoId,
		eventId: messageId,
		pongs: [{ type: 'seen', member_id: userId, created: +new Date() }]
	})
	const resp = await api.markAsSeen(state.userMask, accountId, convoId, messageId)
	return resp
}

export const markAsReceivedMessage = async ({ commit, state }, { accountId, convoId, messageId, userId }) => {
	if (state.isOffline) return
	commit(types.UPDATE_PONG_MESSAGE, {
		convoId,
		eventId: messageId,
		pongs: [{ type: 'receive', member_id: userId, created: +new Date() }]
	})
	const resp = await api.markAsReceived(state.userMask, accountId, convoId, messageId)
	return resp
}

export const getEvents = async ({ commit, state }, { accountId, convoId, limit, forceUpdate }) => {
	if (state.isOffline) return
	let events = []
	let prevAnchor = ''

	if (!forceUpdate) {
		const ended = objectPath.get(state.eventEnds, convoId, false)
		if (ended) {
			return events
		}
		prevAnchor = objectPath.get(state.eventAnchors, convoId, '')
	}
	events = await api.getMessages(state.userMask, accountId, convoId, -1 * (limit + 1), {
		start_id: prevAnchor,
	})
	// utils.log('get conversation events:', events)

	if (utils.size(events) <= limit) {
		commit(types.SET_EVENT_ENDS, { convoId, ended: true })
	}

	// has more
	if (utils.size(events) > limit) {
		events = events.slice(0, limit)
	}

	// because limit is negative
	events.reverse()

	if (events && events.length > 0) {
		commit(types.ADD_EVENTS, { convoId, events, position: 'begin' })
	}

	const anchor = objectPath.get(events, '0.id')
	utils.log('anchor', anchor)

	commit(types.SET_EVENT_ANCHORS, { convoId, anchor })

	return events
}

export const getBatchEvents = async ({ commit, state }, { accountId, convoIds, limit }) => {
	if (state.isOffline) return

	const params = {
		'x-user-mask': state.userMask,
		limit: -1 * limit,
	}

	const ops = []
	for (let convoId of convoIds) {
		const q = querystring.stringify(params)
		ops.push({
			method: 'GET',
			url: `/4.0/conversations/${convoId}/messages?${q}`,
		})
	}

	const result = await api.sendBatchRequest('get-conversations-events', ops)

	for (let i in convoIds) {
		const status = objectPath.get(result, i + '.status', 0)
		if (status !== 200) continue

		const convoId = convoIds[i]

		let events = objectPath.get(result, i + '.body', [])
		if (utils.size(events) < limit) {
			commit(types.SET_EVENT_ENDS, { convoId, ended: true })
		}

		// because limit is negative
		events.reverse()

		if (utils.size(events) > 0) {
			commit(types.ADD_EVENTS, { convoId, events, position: 'begin' })
		}

		const anchor = objectPath.get(events, '0.id')
		utils.log('anchor', anchor)

		commit(types.SET_EVENT_ANCHORS, { convoId, anchor })
	}
}

export const getConvo = async ({ commit, dispatch, state, getters }, { accountId, convoId }) => {
	if (state.isOffline) return
	const convoIds = getters.convoIds || {}
	if (!convoIds[convoId]) {
		eventHub.$emit('widget.conversation_added', convoId)
	}
	const convo = await api.getConversation(state.userMask, accountId, convoId)
	commit(types.ADD_CONVO, { convo, position: 'begin' })

	await dispatch('getEvents', { accountId, convoId, limit: state.eventLimit })

	return convo
}

export const getGeoIP = async ({ commit, state }) => {
	if (state.isOffline) return
	const geoIP = await api.getGeoIP()
	commit(types.SET_GEOIP, geoIP)
	return geoIP
}

export const subscribePushNotification = async ({ commit, state }) => {
	if (state.isOffline) return
	if (state.fcmToken) {
		const fcmToken = state.fcmToken
		const res = await api.updateFcmToken(state.userMask, fcmToken)
		if (res && (res.error || res.error500)) {
			utils.log('error')
			return false
		}
	} else {
		const width = 480
		const height = 440
		const left = (screen.width - width) / 2
		const top = (screen.height - height) / 2

		const langPrefixURL = utils.absURL(state.accountSetting.language_url || '')
		const langCode = state.languageCode
		const langurl = btoa(langPrefixURL + langCode + '.json')
		let url = `${process.env.VUE_APP_BASE_URL}/push_noti_iframe.html#subscribe?langCode=${langCode}&langUrl=${langurl}`
		const popup = window.open(
			url,
			'Subscribe Push Notification',
			`toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,
		width=${width}px,height=${height}px,left=${left}px,top=${top}px`,
		)
		if (window.focus) {
			popup.focus()
		}
	}
	while (!state.fcmToken) {
		await utils.sleep(500)
	}
	return true
}

export const unsubscribePushNotification = async ({ commit, state }) => {
	if (state.isOffline) return
	if (!state.fcmToken) return
	commit(types.SET_FCM_TOKEN, null)
	await api.deleteFcmToken(state.userMask, state.fcmToken)
	return true
}

export const checkPushNotification = async ({ state }) => !!state.fcmToken

export const sendPresence = ({ state }, { accountId, userId, device }) => {
	if (state.isOffline) return
	api.sendPresence(state.userMask, accountId, userId, device)
}

export const sendContent = ({ state }, { accountId, userId, device, pageUrl, pageTitle }) => {
	if (state.isOffline) return
	api.sendContent(state.userMask, accountId, userId, device, pageUrl, pageTitle)
}

export const recordDomain = ({ state }, { accountId, userId, pageUrl }) => {
	if (state.isOffline) return
	api.recordDomain({ a: accountId, u: userId, p: pageUrl })
}

export const endConvo = ({ state }, { accountId, convoId }) => {
	if (state.isOffline) return
	return api.end(state.userMask, accountId, convoId)
}

export const sendTyping = ({ state }, { convoId }) => {
	if (state.isOffline) return
	return api.sendTyping(state.userMask, convoId)
}

export const uploadFileToS3 = async ({ state }, { accountId, files }) => {
	if (state.isOffline) return
	return api.uploadToS3(state.userMask, accountId, files)
}

export const initWebsocket = ({ commit, state, dispatch }, { accountId, userId }) => {
	if (state.isOffline) return

	if (socket) {
		socket.destroy()
		socket = null
	}

	socket = new WS({
		pickUrl: done => {
			let id = Math.round(Math.random() * (NUMBER_OF_SERVER_WS - 1))
			done(WS_URL.replace('*ID*', id))
		},
		maxReconnectAttempts: 20,
	})

	socket.onerror = (event, logError) => {
		utils.log('Websocket:', ' server websocket error')
	}

	socket.onopen = async (ev, id) => {
		utils.log('connectionId:', id)
		if (state.connectionId && id !== state.connectionId) {
			commit(types.DELETE_CONVO_LIST)
			dispatch('getConversations', { accountId, userId })
		}

		commit(types.SET_CONNECTION_ID, id)

		const events = [
			`conversation_state_updated.account.${accountId}.user.${userId}`,
			`conversation_joined.account.${accountId}.user.${userId}`,
			`conversation_left.account.${accountId}.user.${userId}`,
			`conversation_typing.account.${accountId}.user.${userId}`,
			`message_sent.account.${accountId}.user.${userId}`,
			`conversation_pending.account.${accountId}.user.${userId}`,
			`user_info_updated.account.${accountId}.user.${userId}`,
			`message_pong.account.${accountId}.user.${userId}`
		]
		await api.subscribe(state.userMask, accountId, id, events)
		commit(types.SET_WS_READY, true)
	}

	socket.ondead = () => {
		dispatch('initWebsocket', { accountId, userId })
	}

	socket.onmessage = (event, message, offset) => {
		utils.log('[WS] message:', event)
		if (!state.convoListReady) {
			eventQueue.push({ message, offset })
			return true
		}
		onEvent({ state }, message, offset)
	}
}

const onEvent = async ({ state }, message, offset) => {
	offset && socket.commit(offset)

	const type = message.type || ''
	if (!type) return

	const INTEGRATION_ID = utils.getIntegrationId(state.accountId)

	// ignore if event come from another integration
	if (utils.startsWith(type, 'conversation_')) {
		let convoId = objectPath.get(message, 'data.conversation.id', '')
		if (!convoId) return
		let convo = state.conversations.find(convo => convo.id === convoId)
		if (!convo) {
			convo = await api.getConversation(state.userMask, state.accountId, convoId)
		}
		const integrationId = objectPath.get(convo, 'integration.id', '')
		if (!integrationId || integrationId !== INTEGRATION_ID) return
	}

	// ignore if event come from another integration
	if (utils.startsWith(type, 'message_')) {
		let convoId = objectPath.get(message, 'data.message.conversation_id', '')
		if (!convoId) return
		let convo = state.conversations.find(convo => convo.id === convoId)
		if (!convo) {
			convo = await api.getConversation(state.userMask, state.accountId, convoId)
		}
		const integrationId = objectPath.get(convo, 'integration.id', '')
		if (!integrationId || integrationId !== INTEGRATION_ID) return
	}

	eventHub.$emit(message.type, message)
}
